import React from "react";
import AIPromptList from "@/components/AIPromptList";

export default function MasterAIPrompts() {
  return (
    <div className="space-y-6" data-testid="master-ai-prompts-page">
      <div>
        <div className="label-overline">Admin · Library</div>
        <h1 className="font-display font-extrabold text-4xl tracking-tight">
          Master AI Prompts
        </h1>
        <p className="text-sm text-zinc-500 mt-2 max-w-2xl">
          The canonical library of canned questions for the AI Assistant. Every
          new client is created with a copy of this list, and prompts that get
          ticked &ldquo;Also add to Master&rdquo; on any client&apos;s AI page flow back into here.
        </p>
      </div>

      <AIPromptList
        listUrl="/ai-prompts/master"
        createUrl="/ai-prompts/master"
        title="Master library"
        subtitle="These prompts seed the AI page for every new client. Existing clients keep their own copies — edits here only affect future clients."
      />
    </div>
  );
}
